var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDiscordWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/discord-white") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.3302818,3.97759434 C18.776719,3.25072092 17.115576,2.72245956 15.3788967,2.4216628 C15.1656116,2.80727353 14.9164335,3.32592834 14.7446343,3.73851635 C12.8984996,3.46088058 11.0693407,3.46088058 9.2571578,3.73851635 C9.08539144,3.32592834 8.83055476,2.80727353 8.61536154,2.4216628 C6.87680691,2.72245956 5.2137558,3.25266197 3.66019299,3.98144354 C0.526642796,8.71664849 -0.322811145,13.334239 0.101916648,17.8862617 C2.18025186,19.4383111 4.19440909,20.3811344 6.17457495,20.9980918 C6.66348894,20.3252059 7.09953404,19.609913 7.47517633,18.8560623 C6.75975181,18.5842167 6.07452869,18.2487442 5.42707377,17.8592843 C5.59884014,17.7320305 5.766856,17.5989864 5.92918032,17.4620932 C9.87819471,19.3091491 14.1688995,19.3091491 18.0707366,17.4620932 C18.234969,17.5989864 18.402952,17.7320305 18.5728431,17.8592843 C17.9234801,18.2506524 17.2363816,18.5861249 16.5209571,18.8580033 C16.8965994,19.609913 17.3307692,20.327147 17.8215585,21 C19.8036325,20.3830426 21.8196584,19.4402521 23.8979953,17.8862617 C24.3963513,12.6093067 23.0466644,8.0341231 20.3302818,3.97759434 Z M8.01317583,15.0868087 C6.82772141,15.0868087 5.85555206,13.9801148 5.85555206,12.6324348 C5.85555206,11.2847547 6.80696206,10.1761527 8.01317583,10.1761527 C9.2194225,10.1761527 10.191559,11.2828137 10.1707996,12.6324348 C10.1726748,13.9801148 9.2194225,15.0868087 8.01317583,15.0868087 Z M15.986741,15.0868087 C14.8012866,15.0868087 13.8291173,13.9801148 13.8291173,12.6324348 C13.8291173,11.2847547 14.7804943,10.1761527 15.986741,10.1761527 C17.1929548,10.1761527 18.1651242,11.2828137 18.1443648,12.6324348 C18.1443648,13.9801148 17.1929548,15.0868087 15.986741,15.0868087 Z",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/discord-white",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    xlinkHref: "#path-1"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDiscordWhite);
export default __webpack_public_path__ + "static/media/discord-white.cf24fa94ffc43902e05835d4b3805939.svg";
export { ForwardRef as ReactComponent };